module.exports = __webpack_public_path__ + "static/media/05-search.8ca30ab4.png";